import { ChevronRight, Folder, Sparkles } from "lucide-react";
import React from "react";

const AiRephraseIcon = ({
  item,
  handleAIRephrase,
  handleUpdateItem,
  setModalOpen,
  setModalType,
  index,
  setSelectedRowIndex,
}) => {
  return (
    <div>
      {/* Description */}
      <div
        className="flex items-center gap-2 min-w-0 group/desc"
        style={{ paddingLeft: `${(item.level - 1) * 12}px` }}
      >
        {item.level === 1 ? (
          <Folder size={14} className="text-yellow-500 shrink-0" />
        ) : (
          <ChevronRight size={12} className="text-slate-300 shrink-0" />
        )}

        <div className="relative flex-1 flex items-center">
          <input
            className={`w-full bg-transparent border-none focus:ring-0 text-sm font-medium truncate placeholder:text-slate-300 transition-opacity ${
              item.isRephrasing
                ? "opacity-30 pointer-events-none"
                : "opacity-100"
            }`}
            value={item.label}
            placeholder="Type description here... or (F2) "
            onChange={(e) => handleUpdateItem(index, { label: e.target.value })}
            onKeyDown={(e) => {
              if (e.key === "F2") {
                setModalType("productList");
                setModalOpen(true);
                setSelectedRowIndex(index);
              }
            }}
          />

          <button
            disabled={item.label?.trim().length <= 10 || item.isRephrasing}
            onClick={() => handleAIRephrase(index)}
            className={`absolute right-0 p-1 border rounded-md transition-all 
    ${
      item.label?.trim().length > 10 && !item.isRephrasing
        ? "bg-white text-purple-600 border-purple-100 shadow-sm hover:text-purple-700  cursor-pointer"
        : "bg-slate-50 text-slate-300 border-slate-100 cursor-not-allowed opacity-60"
    }`}
            title={
              item.label?.trim().length <= 10
                ? "Type more to enable AI rephrase"
                : "AI Rephrase"
            }
          >
            <Sparkles
              size={12}
              fill={item.label?.trim().length > 10 ? "currentColor" : "none"}
              className={item.isRephrasing ? "animate-spin" : ""}
            />
          </button>

          {/* Rephrasing Loader */}
          {item.isRephrasing && (
            <div className="absolute left-0 flex items-center gap-2">
              <div className="flex gap-1">
                <span className="w-1 h-1 bg-purple-500 rounded-full animate-bounce"></span>
                <span className="w-1 h-1 bg-purple-500 rounded-full animate-bounce [animation-delay:0.2s]"></span>
                <span className="w-1 h-1 bg-purple-500 rounded-full animate-bounce [animation-delay:0.4s]"></span>
              </div>
              <span className="text-[10px] text-purple-500 font-bold italic">
                AI Rephrasing...
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AiRephraseIcon;
